(function(){

  // ===== Inventory quotes (MISSING right now) =====
  function getInventoryQuote(title){
    var t = (title || "").toLowerCase();

    if (t.includes("founding")) {
      return "On the other side of the sea… is freedom. That’s what I always believed. But I was wrong. On the other side of the sea… are more enemies. This is exactly how I saw it in the Founder’s memories. Hey, if we destroy all our enemies over the sea, will we finally be free?";
    }

    if (t.includes("attack")) {
      return "The titan you will inherit is special. No matter which era this titan has found itself in, it has ever pushed forward, seeking out freedom. For the sake of freedom, it fights. Its name… The Attack Titan.";
    }

    if (t.includes("humanity's last hope") || t.includes("humanitys last hope") || t.includes("humanity")) {
      return "There is no future where humanity can inhabit these lands without Eren. The fate of humanity will be determined in this very moment! And so I ask you once again, to give your hearts and charge!";
    }

    return "";
  }


  function onReady(fn){
    if(document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  onReady(function(){

    /* ===== Asset data ===== */
    var data = document.getElementById("mi-data") || {};
    var openCursor   = data.dataset ? data.dataset.openCursor : "";
    var closedCursor = data.dataset ? data.dataset.closedCursor : "";
    var squareBg     = data.dataset ? data.dataset.squareBg : "";
    var rectBg       = data.dataset ? data.dataset.rectBg : "";

    /* ===== Inject cursor CSS ===== */
    if(openCursor && closedCursor){
      var css = `
        html, body { cursor: url(${openCursor}), auto; }
        html.cursor-down, body.cursor-down { cursor: url(${closedCursor}), auto !important; }
      `;
      var style = document.createElement("style");
      style.textContent = css;
      document.head.appendChild(style);
    }

    function press(){
      document.documentElement.classList.add("cursor-down");
      document.body.classList.add("cursor-down");
    }
    function release(){
      document.documentElement.classList.remove("cursor-down");
      document.body.classList.remove("cursor-down");
    }

    window.addEventListener("mousedown", press);
    window.addEventListener("mouseup", release);
    window.addEventListener("mouseleave", release);
    window.addEventListener("touchstart", press, {passive:true});
    window.addEventListener("touchend", release, {passive:true});
    window.addEventListener("touchcancel", release, {passive:true});

    /* ===== Background video ===== */
    var v = document.getElementById("bgVideo");
    if(v){
      var DESKTOP = v.dataset.desktop || "";
      var MOBILE  = v.dataset.mobile  || "";
      var POSTER  = v.dataset.poster  || "";

      function isDesktop(){ return window.innerWidth > 999; }

      function setSource(){
        var src = isDesktop() ? DESKTOP : MOBILE;
        if(src && v.currentSrc !== src){
          v.muted = true;
          v.autoplay = true;
          v.setAttribute("playsinline","");
          v.setAttribute("webkit-playsinline","");
          if(!isDesktop() && POSTER) v.poster = POSTER;
          else v.removeAttribute("poster");

          v.src = src;
          v.preload = "auto";
          v.load();
          v.play().catch(function(){});
        }
      }

      setSource();
      v.addEventListener("canplay", function(){ v.play().catch(function(){}); }, {once:true});
      window.addEventListener("resize", setSource);
    }

    /* ===== Apply obsidian textures ===== */
    var panels = document.querySelectorAll(".obsidian-panel");
    panels.forEach(function(p){
      if(window.innerWidth > 999){
        if(squareBg) p.style.backgroundImage = "url("+squareBg+")";
      }else{
        if(rectBg) p.style.backgroundImage = "url("+rectBg+")";
      }
    });

    window.addEventListener("resize", function(){
      panels.forEach(function(p){
        if(window.innerWidth > 999){
          if(squareBg) p.style.backgroundImage = "url("+squareBg+")";
        }else{
          if(rectBg) p.style.backgroundImage = "url("+rectBg+")";
        }
      });
    });

    /* ===== Item selection logic ===== */
    var container  = document.querySelector(".obsidian-container");
    var detailsBox = document.getElementById("mi-details");

    // Detect mobile / touch device
    var coarse = window.matchMedia("(hover: none), (pointer: coarse)");

    /* ===== Controls available whether logged in OR logged out ===== */

    // Return arrow hover + click sounds
    var back = document.querySelector(".wm-back");
    if (back){
      back.addEventListener("mouseenter", function(){
        if (coarse.matches) return;
        if (window.playHover) window.playHover();
      });

      back.addEventListener("click", function(){
        if (window.playClick) window.playClick();
      });
    }

    // Logged-out login button hover + click sounds
    var loginBtn = document.querySelector(".mi-locked .mi-link");
    if (loginBtn){
      loginBtn.addEventListener("mouseenter", function(){
        if (coarse.matches) return;
        if (window.playHover) window.playHover();
      });

      loginBtn.addEventListener("click", function(){
        if (window.playClick) window.playClick();
      });
    }

    /*
      Everything below here requires the logged-in inventory UI.
      Logged-out users can safely stop here.
    */
    if(!container || !detailsBox) return;

    // Generic hover sound on desktop when hovering items
    container.addEventListener("mouseenter", function(e){
      if (coarse.matches) return;

      if (e.target && e.target.closest && e.target.closest(".mi-item")){
        if (window.playHover) window.playHover();
      }
    }, true);

    function clearActive(){
      container.querySelectorAll(".mi-item.is-active").forEach(function(i){
        i.classList.remove("is-active");
      });
    }

    function playBadgeSfx(sfx){
      var audio = sfx && document.getElementById("sfx-" + sfx);
      if(audio){
        try{ audio.currentTime = 0; audio.play().catch(function(){}); }catch(e){}
      }
    }

    function writeDetails(el){
      var kind  = el.dataset.kind || "";
      var title = el.dataset.title || "";
      var desc  = el.dataset.desc  || "";

      // Badge
      if(kind === "badge"){
        var name = title.replace(/^Badge Acquired:\s*/i,"").trim() || title;

        detailsBox.innerHTML =
          '<div class="mi-badge-details">' +
            '<p class="mi-badge-head text-white">Badge Acquired</p>' +
            '<p class="mi-badge-name text-gold-outline">' + name + '</p>' +
          '</div>';
        return;
      }

      // Inventory (use quote styling from your one-file code)
      var quote = getInventoryQuote(title) || "";


      // If you ever want to use data-desc instead, uncomment next line:
      // if(!quote && desc) quote = desc;

      detailsBox.innerHTML =
        '<div class="mi-badge-details">' +
          '<p class="mi-item-name text-gold-outline">' + title + '</p>' +
          (quote ? '<p class="mi-quote">' + quote + '</p>' : '') +
        '</div>';
    }


    function handleSelect(el){
      clearActive();
      el.classList.add("is-active");
      writeDetails(el);

      if(el.dataset.kind === "badge"){
        playBadgeSfx(el.dataset.sfx);
      }else{
        if(window.playClick) window.playClick();
      }
    }

    container.addEventListener("click", function(e){
      var el = e.target.closest(".mi-item");
      if(el) handleSelect(el);
    });

    container.addEventListener("touchend", function(e){
      var el = e.target.closest(".mi-item");
      if(el) handleSelect(el);
    }, {passive:true});

    document.addEventListener("click", function(e){
      if(!e.target.closest(".mi-item")){
        clearActive();
        detailsBox.innerHTML = '<p class="mi-details-text">Select a badge or item to see its details</p>';
      }
    });
  });

})();